import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Grid from '@material-ui/core/Grid';

import Textfield from 'components/common/Textfield';
import { ActionButton } from 'components/common/buttons';

import { USERNAME_MAX_LENGTH } from 'settings/constants/common';

const LoginForm = ({ value, onClick, onChange }) => {
  const { formatMessage } = useIntl();

  return (
    <Grid container justify="center" alignItems="center" className="mb3 home--login-form">
      <Textfield
        id="login-username"
        isLeftAsset
        hasLeftIcon
        value={value}
        maxLength={USERNAME_MAX_LENGTH}
        rightIcon="close"
        leftIcon="userRound"
        className="textfield--login"
        onChange={e => onChange('username', e.target.value)}
        placeholder={formatMessage({ id: 'login.username.placeholder' })}
      />

      <ActionButton
        hasRightIcon
        isAssetIcon
        icon="lock"
        onClick={onClick}
        hasLeftIcon={false}
        className="db btn--login"
        title={formatMessage({ id: 'buttonText.login' })}
      />
    </Grid>
  );
};

LoginForm.defaultProps = { value: '' };

LoginForm.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default LoginForm;
